module.exports = __webpack_public_path__ + "687d80419fc8a9f30a714df3384b57d6.svg";